import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import OutOfOrder from './views/OutOfOrder.vue';
import OrderList from './views/OrderList.vue';
import Order from './views/Order.vue';
import Buy from './views/Buy.vue';
import BuyItems from './views/BuyItems.vue';
import BuySubmit from './views/BuySubmit.vue';
import LeadsList from './views/LeadsList.vue';
import Lead from './views/Lead.vue';
import { authenticate } from '@/utils/api';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      // component: OutOfOrder,
      component: Login,
      beforeEnter: async (to, from, next) => {
        if (localStorage.getItem('ed-authToken')) {
          try {
            const data = await authenticate(localStorage.getItem('ed-authToken'));
            console.log('authenticated with', data);
            // TODO: if user is a rep, redirect to customers page
            if (data && data.details && data.details.role === 'rep') {
              console.log('rep: ', data);
              next({ name: 'customers' });
            } else {
              next({ name: 'orders', params: { customerId: data.details.id } });
            }
          } catch (err) {
            console.log(err);
            // TODO: replace with "unable to access server right now" page
            next({ name: 'login' });
          }
        } else {
          next({ name: 'login' });
        }
      },
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      // component: OutOfOrder,
      props: route => ({ redirect: route.query.redirect }),
    },
    {
      path: '/customers',
      name: 'customers',
      // component: OutOfOrder,
      component: () => import(/* webpackChunkName: "customers" */ './views/Customers.vue'),
    },
    {
      path: '/customers/:customerId/orders',
      name: 'orders',
      // component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      // component: OutOfOrder,
      component: OrderList,
      props: true,
    },
    {
      path: '/customers/:customerId/orders/:orderId',
      name: 'order',
      // component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      // component: OutOfOrder,
      component: Order,
      props: true,
    },
    {
      path: '/leads',
      name: 'leads',
      // component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      // component: OutOfOrder,
      component: LeadsList,
      props: true,
    },
    {
      path: '/leads/:leadId',
      name: 'lead',
      // component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      // component: OutOfOrder,
      component: Lead,
      props: true,
    },
    {
      path: '/calendar/:year?/:month?/:day?',
      name: 'calendar',
      // component: OutOfOrder,
      component: () => import(/* webpackChunkName: "calendar" */ './views/LeadsCalendar.vue'),
      props: true,
    },
    {
      path: '/calendar/:year/:month/:day/day',
      name: 'leads-day',
      // component: OutOfOrder,
      component: () => import(/* webpackChunkName: "leads-day" */ './views/LeadsDay.vue'),
      props: true,
    },
    {
      path: '/buy',
      component: Buy,
      beforeEnter: async (to, from, next) => {
        if (localStorage.getItem('ed-authToken')) {
          next();
        } else {
          next(false);
        }
      },
      children: [
        {
          path: '',
          name: 'buyItems',
          component: BuyItems,
        },
        {
          path: 'items',
          component: BuyItems,
        },
        {
          path: 'review',
          component: Order,
          name: 'buyReview',
          props: { orderId: 'review' },
        },
        {
          path: 'submit',
          component: BuySubmit,
          name: 'buySubmit',
        },
      ],
    },
  ],
});
